import React, { useEffect } from "react";
import { useArrayContext } from "../../../state/ArrayContext";
import { useSiteContext } from "../../../state/SiteContext";
import { SourceItem } from "../../../shared/models/source-item.model";
import { services } from "../../../globals";
import { MetadataRequest } from "../../../shared/models/metadata-request.model";

/***
 * Array source that returns all values of a custom property from metadata on the site that match the filter.
 */
export const LanguageValuesQuery = React.memo(function LanguageValuesQuery(): React.ReactElement {
    const { setArray } = useArrayContext();
    const { siteState } = useSiteContext();

    useEffect(() => {
        let isMounted = true;

        const fetchData = async () => {
            if (siteState.site?.name) {
                const request: MetadataRequest = {};
                const valueItems: Array<SourceItem> = await services.search.getPropertyValueSet(
                    siteState.site?.name || "",
                    request,
                    "lang",
                    false,
                    true,
                );
                const result = valueItems.map((item, ix) => {
                    return { ...item, position: ix + 1 };
                });
                if (isMounted) {
                    setArray(result);
                }
            }
        };
        fetchData();
        return () => { isMounted = false; };
    }, [siteState, setArray]);

    return <></>;
});